export default __webpack_public_path__ + "static/media/E.7ea569b7.svg";